import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import 'rxjs/add/operator/take';
import { GET_BLACKLIST_SUCCESS, GetBlacklistAction } from './blacklist.actions';
import { IState } from '../../shared/models/state';
import { DefaultParams } from './blacklist.config';

@Injectable()
export class BlacklistResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.store.dispatch(new GetBlacklistAction(new DefaultParams()));
    return this.action$.ofType(GET_BLACKLIST_SUCCESS).take(1);
  }
}
